(async function () {
    async function matchedProductsForSwatches(title) {
        const firstWord = title.split(" ")[0]?.toLowerCase();
        if (!firstWord) return [];

        const allProducts = await fetchAllProducts();

        // Exact match of first word
        return allProducts.filter(p => {
            const productFirstWord = p.title.split(" ")[0]?.toLowerCase();
            return productFirstWord === firstWord;
        });
    }

    async function fetchAllProducts(cursor = null, products = []) {
        const domain = window.Shopify.shop;
        const token = "bc07d5e08e1ee115433ae26b7bb0216f";
        const query = `
            query getProducts($cursor: String) {
                products(first: 250, after: $cursor) {
                    edges {
                        node {
                            title
                            handle
                        }
                        cursor
                    }
                    pageInfo {
                        hasNextPage
                    }
                }
            }
        `;

        const res = await fetch(`https://${domain}/api/2025-01/graphql.json`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Shopify-Storefront-Access-Token": token,
            },
            body: JSON.stringify({ query, variables: { cursor } }),
        });

        const json = await res.json();

        if (!json.data || !json.data.products) {
            console.error("Failed to fetch products:", json);
            return products;
        }

        const newProducts = json.data.products.edges.map(edge => edge.node);
        products.push(...newProducts);

        if (json.data.products.pageInfo.hasNextPage) {
            const lastCursor = json.data.products.edges.slice(-1)[0].cursor;
            return fetchAllProducts(lastCursor, products);
        }

        return products;
    }

    async function displaySwatches(container) {
        if (!container) return;

        const title = container.getAttribute('data-product-title');
        const handle = container.getAttribute('data-product-handle');

        if (!title || !handle) return;

        const matchedProducts = await matchedProductsForSwatches(title);

        if (matchedProducts.length > 0) {
            container.innerHTML = `
                <legend class="label">Color</legend>
                <div class="option-selector__btns" data-firstswatch="${handle}">
                    ${matchedProducts.map(p => `
                        <a
                            href="/products/${p.handle}"
                            class="opt-label tooltip ${p.handle === handle ? 'active' : ''}"
                            data-swatch="${p.title.split(" ").slice(1).join("-").toLowerCase()}"
                        >
                            <span class="tooltiptext">${p.title.split(" ").slice(1).join(" ")}</span>
                        </a>`).join("")}
                </div>
            `;
        }
    }
    displaySwatches(document.getElementById('color-custom-rock'));
    setTimeout(() => {
        const containerSwatches = document.querySelectorAll(".color-custom-rock");
        for (const container of containerSwatches) {
            displaySwatches(container);
        }
    }, 2500);
    
})();
